import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../../../_services/_nav.service';
import { ListaService } from '../../../../_services/lista.service';
import { SarlaftService } from '../../../../_services/sarlaft.service';
import { EstadoService } from '../../../../_services/estado.service';
import { NivelesSarlaft } from '../../../../_models/sarlaft-niveles';
import { ListaItem } from '../../../../_models/lista-item';
import { Estado } from '../../../../_models/estado';


@Component({
  selector: 'app-sarlaft-editar-niveles',
  templateUrl: './sarlaft-editar-niveles.component.html',
  styleUrls: ['./sarlaft-editar-niveles.component.css']
})
export class SarlaftEditarNivelesComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  codShivamExiste = false;
  guardando = false;
  lisTipoCanal: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;

  listasDecisionesSarlaft: ListaItem[] = [];
  lisTipoProcesosCreditos: SelectItem[] = [];
  lisEstadosNovedades: SelectItem[] = [];
  lisCausalesSolicitudes: SelectItem[] = [];
  mostrarCampoInput: boolean = false;
  niveles: NivelesSarlaft[] = [];
  nivel: NivelesSarlaft;
  validarMaximo: boolean = true;
  rangoDisable: boolean = false;
  codExisteEditar: boolean = true;

  constructor(  private lisServicio: ListaService,
                private nav: NavService,
                private location: Location,
                private conServicio: ConfirmationService,
                private route: ActivatedRoute,
                private fb: FormBuilder,
                private sarlaftService: SarlaftService,
                private estServicio: EstadoService,
                private router: Router,) { }
  ngOnInit(): void {

    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasDecisionesProcesosSarlaft' ),
      this.lisServicio.getMasterDetails( 'ListasTiposProcesosCreditos' ),
      this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ),
      this.estServicio.listado()
    ).subscribe( ([ lisTipoDecisiones, lisTipoProcesosCreditos, lisCausalesSolicitudes, lisEstadosNovedades ]) => {
      this.listasDecisionesSarlaft = lisTipoDecisiones;
      lisTipoProcesosCreditos.map( ( s: ListaItem ) => {
        this.lisTipoProcesosCreditos.push( { label: s.nombre, value: s.idLista } );
      } );
      lisEstadosNovedades.map( ( s: Estado ) => {
        if (s.indicadorHabilitado && s.indicadorEstadoFinal) {
          this.lisEstadosNovedades.push( { label: s.nombre, value: s.idEstado } );
        }
      } );
      lisCausalesSolicitudes.map( ( s: ListaItem ) => {
        this.lisCausalesSolicitudes.push( { label: s.nombre, value: s.idLista } );
      } );
      this.route.params.subscribe( ( params: Params ) => {
        if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
          this.sarlaftService.obtenerPorId( params[ 'id' ] ).subscribe( nivel => {
            this.nivel = nivel;
            this.carServicios();
          } );
        } else {
          this.carServicios();
        }
      });
    });
  }
  carServicios() {
    this.formulario = this.fb.group( {
      idRiesgosSarlaftniveles: [ this.nivel ? this.nivel.idRiesgosSarlaftniveles : null ],
      codigo: [ this.nivel ? this.nivel.codigo : null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      nombre: [ this.nivel ? this.nivel.nombre : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      rangoMinimo: [ this.nivel ? this.nivel.rangoMinimo : null, [ Validators.required, Validators.maxLength( 4 ) ] ],
      rangoMaximo: [ this.nivel ? this.nivel.rangoMaximo : null, [ Validators.required, Validators.maxLength( 4 ) ] ],
      idTipoProcesoCredito: [ this.nivel ? this.nivel.idTipoProcesoCredito : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.nivel ? this.nivel.indicadorHabilitado : true ],
      descripcion: [ this.nivel ? this.nivel.descripcion : null, [ Validators.required ] ],
      idDecisionProcesoSarlaft: [ this.nivel ? this.nivel.idDecisionProcesoSarlaft : this.listasDecisionesSarlaft.length > 0 ? this.listasDecisionesSarlaft[0].idLista : null, [ Validators.required ] ],
      idEstado: [ this.nivel ? this.nivel.idEstado : null ],
      idCausal: [ this.nivel ? this.nivel.idCausal : null ],
    } );
    this.validarTipoDecision();
    this.sarlaftService.obtenerNivelesSarlaft().subscribe( sarlaft => {
      this.niveles = sarlaft.filter(n => n.indicadorHabilitado);
      this.carInformacionInicial = false;
    })
  }
  onSubmit() {
    this.submitted = true;
    const nivel = this.formulario.getRawValue();
    this.validarValorMaximo()
    this.guardando = true;
    if ( this.validarMaximo && this.formulario.valid && (this.nivel && !this.codExisteEditar ? this.codExisteEditar : !this.codExiste) ) {
        this.guardarCanal( nivel );
      } else {
        this.guardando = false;
      }
  }
  guardarCanal( nivel: NivelesSarlaft ) {
    if ( nivel.idRiesgosSarlaftniveles !== '' && nivel.idRiesgosSarlaftniveles !== null && nivel.idRiesgosSarlaftniveles !== undefined ) {
      this.sarlaftService.verificarRango( nivel ).subscribe( response => {
        if (response.estado) {
          this.sarlaftService.actualizar( nivel ).subscribe( rta => {
            this.location.back()
            this.nivel = nivel;
            this.guardando = false;
            this.nav.setMesage( 1 );
          }, error => {
            this.nav.setMesage( 3 );
            this.guardando = false;
          } );
        } else {
          this.conServicio.confirm({
            header: this.nav.buscarMensaje("LBL_CONFIRMACION"),
            message: this.nav.buscarMensaje("SARLAFT.MSG_CONFIRMACION"),
            icon: "fa fa-question-circle",
            accept: () => {
              this.sarlaftService.actualizarBulk( response.listado ).subscribe( rta => {
                this.location.back()
                this.nivel = nivel;
                this.guardando = false;
                this.nav.setMesage( 1 );
              }, error => {
                this.nav.setMesage( 3 );
                this.guardando = false;
              } );
            },
            reject: () => {
              this.guardando = false;
            },
          });
        }
      }, error => {
        this.nav.setMesage( 3 );
      } );
    } else {
      this.sarlaftService.verificarRango( nivel ).subscribe( response => {
        if (!response.estado) {
          this.conServicio.confirm({
            header: this.nav.buscarMensaje("LBL_CONFIRMACION"),
            message: this.nav.buscarMensaje("SARLAFT.MSG_CONFIRMACION"),
            icon: "fa fa-question-circle",
            accept: () => {
              this.sarlaftService.actualizarBulk( response.listado ).subscribe( rta => {
                this.nivel = nivel;
                this.guardando = false;
                this.nav.setMesage( 1 );
              }, error => {
                this.nav.setMesage( 3 );
                this.guardando = false;
              } );
              // this.sarlaftService.crear( nivel ).subscribe( rta => {
              //   this.nivel.idRiesgosSarlaftniveles = rta.idRiesgosSarlaftniveles;
              //   this.guardando = false;
              //   this.nav.setMesage( 1 );
              // }, error => {
              //   this.nav.setMesage( 3 );
              //   this.guardando = false;
              // } );
              this.location.back()
            },
            reject: () => {
              this.guardando = false;
            },
          });
        }else{
          this.sarlaftService.crear( nivel ).subscribe( rta => {
            this.location.back()
            // this.nivel.idRiesgosSarlaftniveles = rta.idRiesgosSarlaftniveles;
            this.guardando = false;
            this.nav.setMesage( 1 );
          }, error => {
            this.nav.setMesage( 3 );
            this.guardando = false;
          } );
        }
      }, error => {
        this.nav.setMesage( 3 );
      } );
    }
  }
  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }
  verificarCodigo( n : boolean = true ) {
    const nivel = this.formulario.getRawValue();
    if( nivel.codigo && nivel.idTipoProcesoCredito ){
      this.codExiste = this.niveles.find( x => x.codigo === nivel.codigo && x.indicadorHabilitado && x.idTipoProcesoCredito === nivel.idTipoProcesoCredito ) ? true : false;
      if( !n && this.nivel && this.codExiste ){
        if(this.f.idTipoProcesoCredito.value === this.nivel.idTipoProcesoCredito){
          this.codExisteEditar = true;
          this.codExiste = false;
        }else{
          this.codExisteEditar = false;
        }

      }
    }
  }

  verificarTipo() {
    this.carInformacionInicial = true;
    const nivel = this.formulario.getRawValue();
    const rangoMinimo = parseFloat(this.formulario.get('rangoMinimo').value);
    if (!nivel.idTipoProcesoCredito) {
      this.carInformacionInicial = false;
      return
    }
    this.sarlaftService.verificarCodigoNivel(nivel.idTipoProcesoCredito).subscribe(
      async (response) => {
        if (response && response.length == 0 && rangoMinimo !== 0) {
          this.f.rangoMinimo.disable();
          this.f.rangoMinimo.setValue(0);
          this.nav.setMesage(0, {
            severity: "info",
            summary: this.nav.buscarMensaje("LBL_ATENCION"),
            detail: this.nav.buscarMensaje("SARLAFT.MSG_RANGOCERO"),
          });
          this.carInformacionInicial = false;
        } else {
          this.f.rangoMinimo.enable();
          this.rangoDisable = false
          this.carInformacionInicial = false;
        }
      },
      (error) => {
        this.rangoDisable = false
        this.carInformacionInicial = false;
        console.error("Error al actualizar:", error);
        this.nav.setMesage(0, {
          severity: "info",
          summary: this.nav.buscarMensaje("LBL_ATENCION"),
          detail: this.nav.buscarMensaje("MSG_ERRORSERVICIO"),
        });
      }
    );
  }
  get f() {
    return this.formulario.controls;
  }
  validarTipoDecision() {
    if( this.listasDecisionesSarlaft && this.listasDecisionesSarlaft.length > 0 ){
      this.mostrarCampoInput = this.listasDecisionesSarlaft.find( x => x.idLista === this.formulario.get('idDecisionProcesoSarlaft').value ).nombre === 'Descartar';
    }else{
      this.mostrarCampoInput = false;
    }
    if ( this.mostrarCampoInput ) {
      this.formulario.get('idEstado').setValidators([Validators.required]);
      this.formulario.get('idCausal').setValidators([Validators.required]);
    } else {
      this.formulario.get('idEstado').clearValidators();
      this.formulario.get('idCausal').clearValidators();
    }
    this.formulario.get('idEstado').updateValueAndValidity();
    this.formulario.get('idCausal').updateValueAndValidity();
  }

  validarValorMaximo() {
    const rangoMaximo = parseFloat(this.formulario.get('rangoMaximo').value);
    const rangoMinimo = parseFloat(this.formulario.get('rangoMinimo').value);

    this.validarMaximo = rangoMaximo > rangoMinimo && rangoMaximo >= 0;
  }
}
